/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FCMResponseDto
 */
export interface FCMResponseDto {
    /**
     * Whether the operation was successful
     * @type {boolean}
     * @memberof FCMResponseDto
     */
    success: boolean;
    /**
     * Message ID returned by FCM (for single sends)
     * @type {string}
     * @memberof FCMResponseDto
     */
    messageId?: string;
    /**
     * Error message if operation failed
     * @type {string}
     * @memberof FCMResponseDto
     */
    error?: string;
    /**
     * Number of failed sends (for batch operations)
     * @type {number}
     * @memberof FCMResponseDto
     */
    failureCount?: number;
    /**
     * Number of successful sends (for batch operations)
     * @type {number}
     * @memberof FCMResponseDto
     */
    successCount?: number;
    /**
     * Individual responses from FCM (for batch operations)
     * @type {Array<object>}
     * @memberof FCMResponseDto
     */
    responses?: Array<object>;
}

/**
 * Check if a given object implements the FCMResponseDto interface.
 */
export function instanceOfFCMResponseDto(value: object): value is FCMResponseDto {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function FCMResponseDtoFromJSON(json: any): FCMResponseDto {
    return FCMResponseDtoFromJSONTyped(json, false);
}

export function FCMResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FCMResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'messageId': json['messageId'] == null ? undefined : json['messageId'],
        'error': json['error'] == null ? undefined : json['error'],
        'failureCount': json['failureCount'] == null ? undefined : json['failureCount'],
        'successCount': json['successCount'] == null ? undefined : json['successCount'],
        'responses': json['responses'] == null ? undefined : json['responses'],
    };
}

export function FCMResponseDtoToJSON(json: any): FCMResponseDto {
    return FCMResponseDtoToJSONTyped(json, false);
}

export function FCMResponseDtoToJSONTyped(value?: FCMResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'messageId': value['messageId'],
        'error': value['error'],
        'failureCount': value['failureCount'],
        'successCount': value['successCount'],
        'responses': value['responses'],
    };
}

